export const FETCHING_GET_JOB_APLICATION_STARTED = 'FETCHING_GET_JOB_APLICATION_STARTED';
export const FETCHING_GET_JOB_APLICATION_COMPLETED = 'FETCHING_GET_JOB_APLICATION_COMPLETED';
export const FETCHING_GET_JOB_APLICATION_FAILED = 'FETCHING_GET_JOB_APLICATION_FAILED';

export const POST_JOB_APLICATION_STARTED = 'POST_JOB_APLICATION_STARTED'
export const POST_JOB_APLICATION_COMPLETED = 'POST_JOB_APLICATION_COMPLETED';
export const POST_JOB_APLICATION_FAILED = 'POST_JOB_APLICATION_FAILED';